import { isNumber } from 'app/utils/types';

const getDota2Period = (timer: string | null): 'night' | 'day' | null => {
  if (timer) {
    const minutes = parseInt(timer.split(':')[0]);
    if (isNumber(minutes)) {
      return minutes % 10 < 5 ? 'day' : 'night';
    }
  }
  return null;
};

export { getDota2Period };
